import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import ClasificacionesQuejaTable from './_ClasificacionesQuejaTable.js';
import EditClasificacionQueja from './_EditClasificacionQueja.js';
const URI = ApiEndpoint + 'administration/';
const ClasificacionesQueja = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [openModal, setOpenModal] = useState(false);
  const [clasificacionesQueja, setClasificacionesQueja] = useState(false);

  const [idClasificacionQuejaEdit, setIdClasificacionQuejaEdit] =
    useState(false);
  const handleClose = () => {
    setOpenModal(false);
    getClasificacionesQueja();
  };

  const getClasificacionesQueja = async () => {
    console.log('entre a getClasificacionesQueja');
    setClasificacionesQueja(null);

    httpClient('GET', URI + 'clasifications/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setClasificacionesQueja(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  useEffect(() => {
    getClasificacionesQueja();
  }, []);

  return (
    <>
      {clasificacionesQueja && (
        <ClasificacionesQuejaTable
          clasificacionesQueja={clasificacionesQueja}
          setIdClasificacionesQuejaToEdit={setIdClasificacionQuejaEdit}
          setOpenModal={setOpenModal}
        ></ClasificacionesQuejaTable>
      )}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={
            (idClasificacionQuejaEdit > 0 ? 'Editar' : 'Agregar') +
            ' Clasificacion'
          }
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditClasificacionQueja
            closeModal={handleClose}
            idClasificacionQueja={idClasificacionQuejaEdit}
          ></EditClasificacionQueja>
        </MyModal>
      )}
    </>
  );
};

export default ClasificacionesQueja;
